<template>
  <div class="menuContent">
    <div class="main">
      <!-- 季节性产品专区 -->
      <div v-for="item in SeasonalZoneList" :key="item.WebFunctionID">
        <div
        class="oneMenu seasonal"
        :class="item.pcicon ? 'pa0' : ''"
        @click="ToCategory(item.WebFunctionID)"
        > 
            <img v-if="item.pcicon" :src="item.pcicon" alt="" style="width: 245px;height: 18px;display: block;" :title="item.ProTitle">
            <span v-else>{{ item.ProTitle }}</span>
        </div>
      </div>
      <!-- 一级菜单 -->
      <div v-for="(item, index) in list" :key="index" class="oneMenu">
        <div class="oneMenu_box">
          <p class="oneProductCataName" :class="oneIndex == index ? 'active': ''" @mouseover.stop="changeOneIndex(index)" @click="toNewCategory(item)">
            {{ item.ProductCataName }}
          </p>
          <div class="rightarrow" v-if="oneIndex == index"></div>
        </div>
        <!-- 二级菜单 -->
        <div class="towMenu" v-show="oneIndex == index">
          <div class="main" :class="[{'alignfiexend':item.childList==0},{'alignflexstart':!(item.cataad && item.cataad.fileName)}]">
            <div
              class="twoProductCataName"
              v-for="(it, d) in item.childList"
              :key="d"
            >
              <div class="twoProductItem" @mouseover.stop="changeTwoIndex(d)" @click.stop="toProductList(it)">
                <img :src="it.Icon" alt="">
                <span class="name">{{ it.ProductCataName }}</span> 
              </div>
              <!-- 三级菜单 -->
              <!-- <div class="third_class">
                <div
                  v-for="(resetThird, idx) in it.childList"
                  :key="idx"
                  class="name"
                  @click.stop="toProductList(resetThird)"
                >
                  <span v-if="idx < it.childList.length - 1"
                    >{{ resetThird.ProductCataName }} /</span
                  >
                  <span v-else>{{ resetThird.ProductCataName }}</span>
                </div>
              </div> -->
              <!-- 广告 -->
              <!-- <div class="advert_space" v-show="twoIndex == d">
                <p class="text">{{ $t("typeNav.recommend") }}</p>
                <ul class="rec_goods">
                  <li v-for="(goods, n) in it.recomlist" :key="n" class="item" @click.stop="toDetail(goods)">
                    <img class="img" :src="goods.Pic" alt="" />
                    <p class="ProductName">{{ goods.ProductName }}</p>
                    <p class="label" v-if="goods.isExclusive">
                      {{ $t("typeNav.exclusive") }}
                    </p>
                  </li>
                </ul>
                <p class="line"></p>
              </div> -->
              
            </div>
            <div class="ad">
              <div class="all"  @click="toNewCategory(item)">>>&nbsp;&nbsp;{{ $t('MemberCenter.typeAll').toUpperCase() }}</div>
              <div class="menulist_img">
                <img v-if="item.cataad && item.cataad.fileName" :src="item.cataad.fileName" alt="" @click="common.linkList(item.cataad)">
              </div>
            </div>
          </div>
          <p class="line"></p>
        </div>
      </div>
      <p class="line"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: [],
    },
    SeasonalZoneList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // navpic:{
    //   type: Object,
    //   default: () => {
    //     return {};
    //   },
    // }
  },
  data() {
    return {
      oneIndex: -1,
      twoIndex: -1,
    };
  },
  mounted(){

  },
  name: "menuList",
  methods:{
    // 一级
    changeOneIndex(index){
        this.oneIndex = index;
        this.twoIndex = -1;
    },
    // 二级
    changeTwoIndex(index){
        this.twoIndex = index;
    },
    // 去专区
    ToCategory(id){
      let linkUrl = `/newWine?SubjectFunctionID=${id}&isShowSelect=1&listtype=w&isFromType=false&isType=false`;
      window.open(linkUrl, '_blank');
    },
    toNewCategory(cata){
      let isShowSelect = 1;
      if (
        cata.ProductCataJumpType == "30" ||
        cata.ProductCataJumpType == "20" ||
        cata.ProductCataJumpType == "40" ||
        cata.ProductCataJumpType == "50"
      ) {
        this.$router.push({
          path: "/newcategory",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: 1,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
            isShowCN: 0,
            ishidden: true,
            ProductCataJumpType: cata.ProductCataJumpType,
            listtype:'c'
          }
        });
      } else if (
        cata.ProductCataName == "Asian" ||
        cata.ProductCataName == "Asiatique"
      ) {
        this.$router.push({
          path: "/newcategory",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: 1,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
            isShowCN: 1,
            ProductCataJumpType: cata.ProductCataJumpType,
            listtype:'c'
          }
        });
      } else {
        if (cata.ParentID == 1433) {
          isShowSelect = 0;
        }
        let ishidden = false;
        if (cata.ParentID == 1433 || cata.ProductCataID == 1433) {
          ishidden = true;
        }
        this.$router.push({
          path: "/newcategory",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: isShowSelect,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
            ishidden: ishidden,
            ProductCataJumpType: cata.ProductCataJumpType,
            listtype:'c'

          }
        });
      }
      this.showFirst = false;
      this.showSecond = false;
      this.showAdvert = false;
    },
    // 其他跳转
    toProductList(cata) {
      let isShowSelect = 1;
      if (
        cata.ProductCataJumpType == "30" ||
        cata.ProductCataJumpType == "20" ||
        cata.ProductCataJumpType == "40" ||
        cata.ProductCataJumpType == "50"
      ) {
        this.$router.push({
          path: "/category",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: 1,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
            isShowCN: 0,
            ishidden: true,
            ProductCataJumpType: cata.ProductCataJumpType,
            listtype:'c'
          }
        });
      } else if (
        cata.ProductCataName == "Asian" ||
        cata.ProductCataName == "Asiatique"
      ) {
        this.$router.push({
          path: "/category",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: 1,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
            isShowCN: 1,
            ProductCataJumpType: cata.ProductCataJumpType,
            listtype:'c'
          }
        });
      } else {
        if (cata.ParentID == 1433) {
          isShowSelect = 0;
        }
        let ishidden = false;
        if (cata.ParentID == 1433 || cata.ProductCataID == 1433) {
          ishidden = true;
        }
        this.$router.push({
          path: "/category",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: isShowSelect,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
            ishidden: ishidden,
            ProductCataJumpType: cata.ProductCataJumpType,
            listtype:'c'

          }
        });
      }
      this.showFirst = false;
      this.showSecond = false;
      this.showAdvert = false;
    },
    // 商品详情
    toDetail(val) {
      this.$router.push({
        path: "/productDetail",
        query: { id: val.ProductID }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../style/base.scss";
@import "../../style/color.scss";
.menuContent {
  width: 247px;
  min-height: 493px;
  padding-top: 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
  background: #fff;
  font-family: EperFontBold;
  z-index: 1100;
  box-shadow: 1px 2px 3px #00000029;
  opacity: 1;
  position: absolute;
  left: 0;
  top: 35px;
  & > .main {
    width: 100%;
    height: 100%;
    border-right: 2px solid #ccc;
    padding: 0 20px 0;
    padding-right: 0;
    padding-left: 0;
    box-sizing: border-box;
    overflow: hidden;
  }
  .oneMenu {
    font-size: 12px;
    color: #000;
    font-weight: bold;
    width: 100%;
    // margin-bottom: 5px;
    .rightarrow{
      border-left: 6px solid #73B75B ; /* 左边边框透明 */
      border-right: 6px solid transparent; /* 右边边框颜色 */
      border-top: 6px solid transparent; /* 顶部边框透明 */
      border-bottom: 6px solid transparent; /* 底部边框透明 */
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.2s linear;
    }
    .oneMenu_box{
      position: relative;
    }
    .oneProductCataName {
      font-size: 12px;
      color: #000;
      font-weight: bold;
      padding:3px 20px;
      padding-right: 20px;
      padding-left: 20px;
      width: 100%;
      box-sizing: border-box;
      @include ellipsis;
    }
    .oneProductCataName.active{
      background: #ebebeb;
      color: $c_6DB;
    }
    .towMenu {
      position: absolute;
      top: 0;
      left: 247px;
      width: 803px;
      // width: 461px;
      height: 100%;
      // padding: 23px 28px 20px 20px;
      padding: 20px 0px 20px 8px;
      box-sizing: border-box;
      background: #fff;
      font-family: "EperFontLight";
      border-right: 1px solid #ccc;
      .main {
        width: 100%;
        height: 100%;
        // border-right: 1px solid #ccc;
        padding-right: 8px;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: flex-start;
        .menulist_img{
          width: 100%;
          &> img{
            width: 100%;
            height: 200px;
            display: block;
          }
        }
      }
      .main.alignfiexend{
        align-content: flex-end;
      }
      .main.alignflexstart{
        align-content: flex-start;
      }
      .all{
        //position: absolute;
        //right: 20px;
        // bottom: 30px;
        text-decoration: underline;
        text-underline-offset: 2px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        color: #6fbf59 ;
        margin-left: auto;
        font-size: 14px;
        height: 18px;
      }
      .all.height109{
        height: 109px;
      }
      .all.height18{
        height: 138px;
        align-items: flex-start;
      }
      .twoProductCataName {
        font-size: 12px;
        font-weight: bold;
        color: $c_000;
        margin-bottom: 5px;
        width: 111px;
        height: 109px;
        .twoProductItem{
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 111px;
          height: 109px;
          .name{
            width: 100%;
            margin-top: 4px;
            text-align: center;
            line-height: 1.2;
            transition: all 0.2s linear;
            @include ellipsisMore(2);
          }
          img{
            width: 98px;
            height: 77px;
            flex-shrink: 0;
            display: block;
            margin: 0 auto;
          }
        }
        .third_class {
          font-size: 12px;
          padding-left: 24px;
          box-sizing: border-box;
          margin-bottom: 5px;
          .name {
            word-break: keep-all;
            word-wrap: break-word;
            display: inline-block;
            padding-right: 5px;
            font-family: EperFontLight;
            font-weight: 400;
            span {
              font-family: EperFontLight;
              color: $c_000;
            }
          }
          & > .name:hover > span {
            color: $c_6DB;
          }
        }
        &:hover > .name {
          color: $c_6DB;
        }
        .advert_space {
          position: absolute;
          left: 536px;
          top: 0;
          width: 293px;
          height: 397px;
          padding: 23px 19px 14px 10px;
          box-sizing: border-box;
          border-right: 1px solid #ccc;
          background: #fff;
          .text {
            margin-bottom: 12px;
            text-align: center;
            font-size: 12px;
            color: #6fbf59;
            font-weight: bold;
          }
          .rec_goods {
            height: 210px;
            .item {
              width: 127px;
              float: left;
              .img {
                width: 127px;
                height: 127px;
                margin-bottom: 9px;
              }
              .ProductName {
                font-size: 12px;
                @include ellipsisMore(2);
                font-family: "EperFontLight";
                color: #000;
                text-align: center;
                &:hover {
                    color:#6fbf59;
                    text-decoration: underline;
                }
              }
            }
            .item:nth-child(odd) {
              margin-right: 9px;
            }
            
          }
          .rec_img {
              width: 100%;
              height: 112px;
              border: 2px solid $c_999;
              padding: 5px;
              box-sizing: border-box;
              img {
                width: 100%;
                height: 100%;
              }
            }
          .line {
            width: 294px;
          }
        }
        .leftLine {
          display: inline-block;
          width: 4px;
          height: 10px;
          background: $c_716;
          margin-right: 14px;
        }
        .leftLine.active {
          background: $c_6DB;
        }
      }
      .ad{
          width: 100%;
      }
      .twoProductCataName:nth-child(7n){
        // width: 98px;
        // .twoProductItem{
        //   margin-right: 0;
        // }
      }
      .line {
        width: 803px;
        // width: 461px;
      }
    }
  }
  .oneMenu .twoProductCataName:hover {
    color: $c_6DB;
  }
  .oneMenu.seasonal {
    color: #fe6b00;
    position: relative;
    padding: 3px 20px;
  }
  .oneMenu.pa0{
    padding:3px 0 !important;
  }
  .line {
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 247px;
    height: 3px;
    background: $c_6DB;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public/menuList.vue